<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'ProfilesSection',
  mounted() {
    this.SET_SECTION('Profiles');
  },
  methods: {
    ...mapMutations(['SET_SECTION']),
  },
};
</script>
